const TAG_REGEX = /(\s|^)tag:(\s)?("[^"]+"|[0-9]+|[^\s]+)/;
const ATTRIBUTE_REGEX = /(\s|^)attribute:(\s)?("[^"]+"|[0-9]+|[^\s]+)/;
const CUSTOM_FIELD_REGEX =
  /(\s|^)field:([^=]+)=(\s)?("((?:[^"\\]|\\")+)"|[0-9]+|[^\s]+)/;
const CATEGORIES_FIELD_REGEX =
  /(\s|^)category:([^=]+)=(\s)?("((?:[^"\\]|\\")+)"|[0-9]+|[^\s]+)/;
const ATTRIBUTE_FIELD_REGEX =
  /(\s|^)attribute:([^=]+)=(\s)?("((?:[^"\\]|\\")+)"|[0-9]+|[^\s]+)/;

const TAG_PREFIX = 'tag:';
const TAG_TYPE_LABEL = 'label';
const TAG_TYPE_ATTRIBUTE = 'attribute';
const TAG_TYPE_CATEGORY = 'category';
const TAG_TYPE_CUSTOM = 'custom';

/* eslint-disable no-cond-assign */
/* eslint-disable padded-blocks */

/**
 * Query parser
 *
 *  SUB-OPERATORS
 *    =
 *    >
 *    <
 *
 *  TERMS
 *    X:Y sub-op Z
 *    X:Y
 *    Z
 *    "Z"
 *
 *    Z: text, "some text", number
 *    Y: text, "some text"
 *    X: reserved words
 *
 *  QUERY LANGUAGE
 *    CATEGORIES: (case sensitive)
 *       category:*some-key    = "value"
 *       category:display-name = "value"
 *       category:"some key"   = value
 *       category:some-key     = 22
 *
 *    FIELDS: (case sensitive)
 *       field:*some-key    = "value"
 *       field:display-name = "value"
 *       field:"some key"   = value
 *       field:some-key     = 22
 *
 *    ATTRIBUTES: (case insensitive)
 *       attribute:some-key = "value"
 *       attribute:some-key = 22
 *       attribute:"some value"
 *
 *    TAGS: (case insensitive)
 *       tag:value
 *       tag:"value"
 *       tag:22
 *
 *  TIPS
 *    Categories and Fields key search by 'tag key' and 'display name'
 *    Tags search by 'key' = NULL and 'value'
 *
 * @param {Object}
 *
 * @returns {Promise}
 */
module.exports = function queryParser() {
  return {
    parseNode,
    parseTag
  };

  /**
   * Parse tagPair and return a valid tag object
   *
   * @returns {Object}
   */
  function parseTag(keyValueTag) {
    const lowerTagPair = keyValueTag.toLowerCase().trim();

    if (keyValueTag.startsWith(TAG_PREFIX)) {
      return {
        key: null,
        value: lowerTagPair.slice(TAG_PREFIX.length)
      };
    }

    const regex = /^(category:)?([^:]+):(.+)$/;
    const match = regex.exec(lowerTagPair);

    if (match) {
      return {
        key: match[2].trim(),
        value: match[3].trim()
      };
    }

    return {
      key: null,
      value: lowerTagPair
    };
  }

  /**
   * Parse a graph node object and returns an object with all structures to search
   *
   * @returns {Promise}
   */
  function parseNode(text) {
    let textWithExpressions = true;
    let query = '';
    const tags = [];

    let textToParse = text;

    while (textWithExpressions && textToParse) {
      let match;

      if ((match = TAG_REGEX.exec(textToParse))) {
        // Tags
        const value = extractFromQuotes(match[3].trim()).toLowerCase();
        tags.push({ key: null, value, type: TAG_TYPE_LABEL });
        textToParse = textToParse.replace(match[0], '').trim();
      } else if ((match = CUSTOM_FIELD_REGEX.exec(textToParse))) {
        // Custom fields
        const key = extractFromQuotes(match[2].trim());
        const value = extractFromQuotes(match[4].trim());

        tags.push({ key, value, type: TAG_TYPE_CUSTOM });
        textToParse = textToParse.replace(match[0], '').trim();
      } else if ((match = CATEGORIES_FIELD_REGEX.exec(textToParse))) {
        // Category
        const key = extractFromQuotes(match[2].trim());
        const value = extractFromQuotes(match[4].trim());

        tags.push({ key, value, type: TAG_TYPE_CATEGORY });
        textToParse = textToParse.replace(match[0], '').trim();
      } else if ((match = ATTRIBUTE_FIELD_REGEX.exec(textToParse))) {
        // Attributes
        const key = extractFromQuotes(match[2].trim()).toLowerCase();
        const value = extractFromQuotes(match[4].trim()).toLowerCase();

        tags.push({ key, value, type: TAG_TYPE_ATTRIBUTE });
        textToParse = textToParse.replace(match[0], '').trim();
      } else if ((match = ATTRIBUTE_REGEX.exec(textToParse))) {
        // Attributes without key
        const value = extractFromQuotes(match[3].trim()).toLowerCase();
        tags.push({ key: null, value, type: TAG_TYPE_ATTRIBUTE });
        textToParse = textToParse.replace(match[0], '').trim();
      } else {
        query = textToParse;
        textWithExpressions = false;
      }
    }

    return { query, tags };
  }

  function extractFromQuotes(string) {
    if (string.charAt(0) === '"' && string.charAt(string.length - 1) === '"') {
      return string.slice(1, -1).replace(/\\"/g, '"');
    }
    return string.replace(/\\"/g, '"');
  }
};
